export function deepCopy(obj) {
  let copy;

  // Handle the 3 simple types, and null or undefined
  if (null == obj || 'object' != typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (let i = 0, len = obj.length; i < len; i++) {
      copy[i] = deepCopy(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (let attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = deepCopy(obj[attr]);
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

export function toFormData(formData: FormData, data: any, parentKey?: string) {
  if (data === null || data === undefined) {
    return;
  }

  if (data instanceof File) {
    formData.append(parentKey!, data);
  } else if (Array.isArray(data)) {
    data.forEach((value, index) => {
      const key = parentKey ? `${parentKey}[${index}]` : index.toString();
      toFormData(formData, value, key);
    });
  } else if (typeof data === 'object') {
    Object.keys(data).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;
      toFormData(formData, data[key], fullKey);
    });
  } else {
    // Gestion des nombres décimaux si besoin
    let value = data;
    if (typeof value === 'number') {
      value = value.toString().replace('.', ',');
    }

    formData.append(parentKey!, value);
  }
}
